import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { fetchTicketStatusCounts } from "@src/apis/statusCheckApis";
import { ITicketStatusCounts } from "@src/types/statusCheck";
import { QUERY_KEYS } from "./queryKeys";

export const useTicketStatusCountsQuery = ({
  enabled = true,
}: { enabled?: boolean } = {}) =>
  useQuery<AxiosResponse<{ data: ITicketStatusCounts }>, Error>({
    queryKey: [QUERY_KEYS.TICKET_STATUS_COUNTS],
    queryFn: fetchTicketStatusCounts,
    enabled,
    // A status check is only useful when it is current, so it always refetches on
    // mount instead of serving the 10-minute default staleTime from cache.
    staleTime: 0,
    refetchOnMount: "always",
  });
